// App action attribute lists can run into the thousands of entries (ShipHawk's shipment actions
// carry ~10k), and step attributes are merged against them for every parent step on every
// editor render. The key set is therefore built once per attribute list and reused for as long
// as that list object lives in the store.
const actionAttributeKeysByList = new WeakMap();

const getActionAttributeKeys = (actionAttributes = []) => {
  const cached = actionAttributeKeysByList.get(actionAttributes);
  if (cached) {
    return cached;
  }

  const keys = new Set(actionAttributes.map((attribute) => attribute?.key));
  actionAttributeKeysByList.set(actionAttributes, keys);
  return keys;
};

export default getActionAttributeKeys;
